const openWeatherMapAPI = 'e7ec64ad75c8f58f1a1726bf7dc6c716';

export default openWeatherMapAPI;
